// extracted by mini-css-extract-plugin
export default {"wrapper":"HorizontalProgressBarCount_wrapper__zsx6V","count":"HorizontalProgressBarCount_count__ZeeqF","clickable":"HorizontalProgressBarCount_clickable__SBYvu"};